import { FaBuilding, FaTimes } from 'react-icons/fa';
import { AiOutlineCheck } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { type MerchantStore } from '../../../common/types';

interface IProps {
  item: MerchantStore;
  pageType?: 'pending' | 'approved';
  actions: any[];
}

const ListStoreItem: React.FC<IProps> = ({ item, pageType = 'approved', actions }) => {
  const statusValue = item.isActive ? 'Active' : 'Inactive';
  const statusClasses = item.isActive ? 'text-green-400' : 'bg-red-500 rounded-lg bg-opacity-90';

  return (
    <tr className="odd:bg-white even:bg-gray-50" key={item.id}>
      <td className="p-2 pl-8 text-sm text-gray-700 whitespace-nowrap">
        <div className="flex flex-col">
          <Link to={`/admin/stores/${item.id}`} className="hover:text-[#1D8A43] flex space-x-2">
            <span>{item.name}</span>
            {item.isDefault ? <FaBuilding color="green" size={18} /> : ''}
          </Link>
          <div className="flex">
            <span className="text-xs text-gray-400">{item.email.toLowerCase()}</span>
            {item.isApproved ? <AiOutlineCheck size={12} color="green" /> : <FaTimes size={12} color="red" />}
          </div>
        </div>
      </td>
      <td className="p-2 text-sm text-gray-700 whitespace-nowrap">{item.address}</td>
      <td className="w-24 p-2 text-sm text-gray-700 whitespace-nowrap">{item.phone}</td>
      <td className="w-24 p-2 text-sm text-gray-700 whitespace-nowrap">
        <span className={`p-1.5 text-xs font-medium text-gray-700 ${statusClasses}`}>{statusValue}</span>
      </td>
      <td className="w-24 p-2 pr-8 text-sm text-left text-gray-700 whitespace-nowrap">
        <div className="flex flex-row justify-center space-x-4">
          {actions.map((action, index) => {
            if (action.type === 'link') {
              return (
                <Link to={action.link} key={index}>
                  <span className="px-1 h-full">{action.icon}</span>
                </Link>
              );
            } else if (action.type === 'component') {
              return <div key={index}>{action.icon}</div>;
            } else {
              return (
                <button
                  key={index}
                  onClick={action.handler}
                  className="py-1 px-2 text-gray-50 text-sm text-center rounded-md"
                >
                  <span className="px-1 h-full">{action.icon}</span>
                </button>
              );
            }
          })}
        </div>
      </td>
    </tr>
  );
};

export default ListStoreItem;
